import { render, staticRenderFns } from "./EditBackground.vue?vue&type=template&id=63bf10b0&scoped=true&"
import script from "./EditBackground.vue?vue&type=script&lang=js&"
export * from "./EditBackground.vue?vue&type=script&lang=js&"
import style0 from "./EditBackground.vue?vue&type=style&index=0&id=63bf10b0&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bf10b0",
  null
  
)

export default component.exports